let Endpoint = {
  serverUrl() {
    let _server_url = "https://super-conversation-service.superagi.com/";

    if (window.WIDGET_ENV === "development") {
      _server_url = "http://localhost:8084/";
    }

    if (window.WIDGET_ENV === "staging") {
      _server_url = "https://super-conversation-service-staging.superagi.com/";
    }

    return _server_url;
  },
  apiUrl() {
    return this.serverUrl() + "api/v1/";
  },
  internalApiUrl() {
    // Use main Rails API for internal endpoints
    let _api_url = "https://api.superagi.com/";

    if (window.WIDGET_ENV === "development") {
      _api_url = "http://localhost:3000/";
    }

    if (window.WIDGET_ENV === "staging") {
      _api_url = "https://devapi.superagi.com/";
    }

    return _api_url + "api/conversation/internal/";
  },
};

export default Endpoint;
